import { ActivatedRoute, Navigation, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export class SurveyRouteParamsComposer {
  private _mappedParams$: Observable<number | null>;
  private _extras$: Observable<{ [k: string]: any }>;

  constructor(
    private readonly _route: ActivatedRoute,
    private readonly _router: Router
  ) {
    this._mappedParams$ = this._route.paramMap.pipe(
      map((params) => (params.get('id') ? Number(params.get('id')) : null))
    );

    this._extras$ = of(
      this._router.getCurrentNavigation() || this._emptyNavigation()
    ).pipe(map((navigation) => navigation.extras.state || {}));
  }

  public nonEdit(): Observable<null> {
    return this._mappedParams$.pipe(filter((param): param is null => !param));
  }

  public edit(): Observable<number> {
    return this._mappedParams$.pipe(
      filter((param): param is number => !!param)
    );
  }

  public extras(): Observable<{ [k: string]: any }> {
    return this._extras$;
  }

  private _emptyNavigation(): Navigation {
    return <Navigation>{
      extras: {
        state: {},
      },
    };
  }
}
